<script setup>
import { ref, watch, nextTick } from 'vue' 
import { messageService } from '@/http'
import { useRoute } from 'vue-router'

const route = useRoute()

const message = ref('')

const messages = ref([])


const fetchData = async () => {
    messageService.get({
        id: route.params.id
    }).then(async (res) => {
        messages.value = res.data
        await nextTick();
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    })
}

const onSubmit = () => {
    messageService.save({
        id: route.params.id,
        text: message.value
    }).then(res => {
        message.value = ''
        fetchData()
    })
    
}

watch(
  () => route.params,
  async () => {
    fetchData()
  },
  {
    flush: 'post',
    immediate: true
  }
)

</script>

<style lang="scss">
.chat {
    padding-top: 50px;
    @include mq('md') {
        padding-top: 0;
    }
    &__messages {
        display: flex;
        align-content: end;
        flex-direction: column;
        gap: 10px;
        align-items: start;
        padding-bottom: 70px;
        @include mq('md') {
            padding-bottom: 0;
            gap: 5px;
        }
    }
    &__message {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
        &--res {
            align-self: flex-end;
            flex-direction: row-reverse;
        }
    }
    &__bottom {
        max-width: $max-width;
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 50px;
        gap: 10px;
        position: fixed;
        bottom: 10px;
        left: 0;
        right: 0;
        padding: 0 10px;

        @include mq('md') {
            position: relative;
        }

    }
    &__send {
        display: flex;
        background: var(--color-gradient);
        border-radius: 6px;
        color: #ffffff;
        align-items: center;
        justify-content: center;
        font-size: 24px;
    }


    &__text {
        background: var(--background-primary);
        border-radius: 6px;
        padding: 10px;
    }
    &__photo {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }
}
</style>

<template>
    <div class="chat">
        <div class="chat__messages">
            <div 
                v-for="item in messages"
                :key="item.id"
                class="chat__message"
                :class="{'chat__message--res' : item.recived}"
            >
                <div class="chat__photo">
                    <img 
                        :src="$root.$pixel"
                        v-lazy="item.photo"
                        alt=""
                    />
                </div>
                <div class="chat__text">
                    {{ item.text }}
                </div>
            </div>
        </div>
        <form class="chat__bottom" @submit.prevent="onSubmit">
            <v-input v-model="message" label="Текст" />
            <button class="chat__send" type="submit">
                <Icon name="paper-plane" />
            </button>
        </form>
    </div>
</template>